import { colors } from '../../colors';
var richText = {
  backgroundColor: colors.whiteish,
  h1Color: colors.graphite,
  h2Color: colors.graphite,
  paraColor: colors.graphite,
  anchorColor: colors.rust
};
export default richText;